
export default class ZXOUtils
{
	static async Call_API(data = {})
	{
		let headers = {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			//'Accept': "application/json, text/plain, *\/*",
		};
	
		let aa = [];
		for (var k in data) {
			aa.push('' + k + '=' + encodeURIComponent(data[k]));
		}
		let fd = aa.join('&');

		let ap = '/wp-admin/admin-ajax.php';
		let domain = document.location.hostname;
		if (domain === 'local.zxonline.net') {
			ap = '//local.zxonline.net' + ap;
		}

		try {
			let response = await fetch(ap, {
				method: 'POST',
				headers: headers,
				body: fd,
				cache: 'no-cache',
			});
	
			let txt = await response.text();
	
			// Go decode JSON
			let res = {
				'code': -200,
				'error': 'No response',
			};
	
			let json = JSON.parse(txt);
	
			if (json) {

				if ('code' in json) {
					return json;
				} else {
					return {
						'code': -102,
						'error': 'WP API response is not success.',
					};	
				}
	
			} else {
				// Not json!
				return {
					'code': -101,
					'error': 'WP API Response is empty.',
				};
			}
	
		} catch (e) {
			console.log('Error while fetching data:');
			console.log(e);
	
			return {
				'code': -100,
				'error': '' + e,
			};
		}
	}
	
}
